import React, { createRef, useState, useEffect } from "react";
import { TextField, Paper } from "react-md";
import { ReactSVG } from "react-svg";
import MathJax from '../react-mathjax-preview';
import Canvas from "./canvas";
import { GetNewComponentGuid } from '../randomized-parameters/CommonHelpers';

import "../../css/VectorStyles.scss";
import arrowSVG from "../../images/vectors/upper-right-arrow.svg";
import dotSVG from "../../images/vectors/dot.svg";
import VectorParserUtil from "../../lib/vector-math-parser";
const VectorFreeFormAnswerLivePreview = ({
  vectorSettings,
  vectorAnswerFormulas,
  showComponents,
  showMagnitudeAngle
}) => {
    return (
      <FreeFormVectorAnswer
      vectorSettings={vectorSettings}
      vectorAnswerFormulas={vectorAnswerFormulas}
      showComponents = {showComponents}
      showMagnitudeAngle = {showMagnitudeAngle}
      />
    );
};

const vectorInitValue = {
  x: 5,
  y: 5,
  strokeWidth:5,
  name: "ans",
  posX: "5",
  posY: "5",
  color: "#0aaafa",
  angleOptions: {
    angleOffset: 0,
    type: 1,
  },
  index: 0,
  initializedIndex: 0
};
const colorPallete = [
  "#F79722",
  "#0AAAFA",
  "#FF5500",
  "#09B83E",
  "#34465D",
  "#E4405F",
];

const FreeFormVectorAnswer = ({
  vectorSettings,
  showVectorAnswer,
  correctAnswerVectors,
  vectorAnswerFormulas,
  showComponents,
  showMagnitudeAngle
}) => {
  const canvasRef = createRef();
  const [vectors, setVectors] = useState([]);
  const [clickedBox, setClickedBox] = useState([]);
  const [planeType, setPlaneType] = useState(null);
  const [isInPlane, setIsInPlane] = useState(false);
  const [isOutPlane, setIsOutPlane] = useState(false);
  const [isZeroVector, setIsZeroVector] = useState(false);
  const [isAngleOrMagnitudeTextFieldChanged, setIsAngelOrMagnitudeTextFieldChanged] = useState(false);
  useEffect(() => {
    if (canvasRef && canvasRef.current && vectors) {
      canvasRef.current.drawVectors({ vectors:vectors });
    } else {
      canvasRef.current.drawVectors({ vectors: [] });
    }
  }, [canvasRef, vectors]);

  const onChange = (arg, type) => {
    onVectorMoved(arg);
    if (type === "angleMag") {
      setIsAngelOrMagnitudeTextFieldChanged(true);
    } else {
      setIsAngelOrMagnitudeTextFieldChanged(false);
    }
  } 

  const onVectorMoved = (vectorArg) => {
    
    const { posX, posY, x, y, initializedIndex: targetIndex } = vectorArg;
    console.debug("posX, posY, x, y", posX, posY, x, y)
    const _vectors = vectors.map((_vector) => {
      if (targetIndex === _vector.initializedIndex) {
        return { ...vectorArg, posY, posX, x, y };
      } else {
        return { ..._vector };
      }
    });
    setVectors(_vectors);
    //onAnswerChange(_vectors);
  };

  useEffect(() => {
    if (showVectorAnswer && correctAnswerVectors) {
      setVectors([...Object.values(correctAnswerVectors)]);
    }
  }, [correctAnswerVectors, showVectorAnswer]);

  useEffect(()=> {
    if (vectorAnswerFormulas && vectorAnswerFormulas.length > 0 ){
      let tempVectors =[]
      for(let index=0;index <= vectorAnswerFormulas.length; index++) {
        let vectorAnswer =vectorAnswerFormulas[index]
        if (vectorAnswer?.isStaticVector) {
          const vector = VectorParserUtil.buildQuestionVariablesMap([vectorAnswer]);
          let staticVector = VectorParserUtil.generateAnswerVector(vectorAnswer, vector, vectorSettings);
      
          if (staticVector) {
              staticVector.isStaticVector = vectorAnswer.isStaticVector
              staticVector.isIncorrectAnswer = vectorAnswer.isIncorrectAnswer
              staticVector = {
                ...staticVector,
                isStaticVector:vectorAnswer.isStaticVector,
                isIncorrectAnswer:vectorAnswer.isIncorrectAnswer,
                name: vectorAnswer.name,
                color:vectorAnswer.formulaColor,
                showComponents:vectorAnswer.showComponents,
                showAngle:vectorAnswer.showAngle,
                index:index,
                initializedIndex:index
              }
              if (!vectorAnswer.autoOrigin) {
                staticVector.posX = vectorAnswer.xOrigin;
                staticVector.posY = vectorAnswer.yOrigin;
              }
              tempVectors.push(staticVector);
          }
      }
      }
      setVectors([...Object.values(tempVectors)]);
    }
  },[vectorAnswerFormulas])
  const handleAngleMagnitudeTextFieldChange = (val) => {
    setIsAngelOrMagnitudeTextFieldChanged(val);
  }

  const onZeroVectorCheckboxClicked = (event, pickedVectorIndex) => {
    setIsZeroVector(event.target.checked)
    setPlaneType("");
    setIsInPlane(false);
    setIsOutPlane(false);
    if (event.target.checked) {
      const _vectors = vectors.map((_vector)=> {
        if(_vector.initializedIndex === pickedVectorIndex){
          return {..._vector, x:0, y:0, plane:'',isZeroVector:true}
        }else{
          return _vector
        }
      })
      setVectors([..._vectors]);
    }else{
      const _vectors = vectors.map((_vector)=> {
        if(_vector.initializedIndex === pickedVectorIndex){
          return {..._vector, x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2),isZeroVector:false}
        }else{
          return _vector
        }
      })
      setVectors([..._vectors]);

    }
  }
 

  const onVectorCheckboxClicked = (event, _vector, index) => {
    setPlaneType("");
    setIsInPlane(false);
    setIsOutPlane(false);
    setIsZeroVector(false);
    // vector name validation 
    if(_vector?.name === undefined || _vector?.name === ""){
      alert("Please choose a vector name for preview")
      return
    }
    if (event.target.checked) {
      if(_vector?.isStaticVector){
        let vectorAnswer =vectorAnswerFormulas[index]
        const vector = VectorParserUtil.buildQuestionVariablesMap([vectorAnswer]);
        let staticVector = VectorParserUtil.generateAnswerVector(vectorAnswer, vector, vectorSettings);
    
        if (staticVector) {
            staticVector.isStaticVector = vectorAnswer.isStaticVector
            staticVector.isIncorrectAnswer = vectorAnswer.isIncorrectAnswer
            staticVector = {
              ...staticVector,
              isStaticVector:vectorAnswer.isStaticVector,
              isIncorrectAnswer:vectorAnswer.isIncorrectAnswer,
              name: vectorAnswer.name,
              color:vectorAnswer.formulaColor,
              showComponents:vectorAnswer.showComponents,
              showAngle:vectorAnswer.showAngle,
              index:index,
              initializedIndex:index
            }
            if (!vectorAnswer.autoOrigin) {
              staticVector.posX = vectorAnswer.xOrigin;
              staticVector.posY = vectorAnswer.yOrigin;
            }
        }
        const newVectorArr = [...vectors, {
                            ...staticVector
                          }];
        setVectors([...newVectorArr]);
        setClickedBox([...newVectorArr]);

      }else {
        let vectorInitial = {
          ...vectorInitValue,
          x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2),
          y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2),
          name: _vector.name,
          color: vectorAnswerFormulas[index].formulaColor,
          showComponents:vectorAnswerFormulas[index].showComponents,
          showAngle:vectorAnswerFormulas[index].showAngle,
          index:index,
          initializedIndex:index,
          isZeroVector:false
        }
  
        if(!vectorAnswerFormulas[index].autoOrigin){
          vectorInitial.posX = vectorAnswerFormulas[index].xOrigin;
          vectorInitial.posY = vectorAnswerFormulas[index].yOrigin;
        }
        const newVectorArr = [...vectors, {
                            ...vectorInitial
                          }];
        setVectors([...newVectorArr]);
        setClickedBox([...newVectorArr]);
      }
    } else {
      const _vectors = vectors.filter((_vector)=> _vector.initializedIndex !== index)
      setVectors([..._vectors]);
      setClickedBox([..._vectors]);
    }
  };

  const onPlaneVectorRadioSelected = (val, pickedVectorIndex) => {
    setIsZeroVector(false);
    const _vectors = vectors.map((_vector)=> {
      if(_vector.initializedIndex === pickedVectorIndex){
        if (val === "") {
          return {..._vector, x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2), plane: val}
        } 
        return {..._vector, x:0, y:0, plane: val}
        // return {..._vector, x:Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y:Math.trunc(parseInt(vectorSettings.heightUnit) / 2), plane: val}
        // return {..._vector, plane: val}
      }else{
        return _vector
      }
    })
    setVectors([..._vectors]);
    
  }

  const handleInPlaneCheckbox = (event, vec) => {
    let value = event.target.checked;
    setIsInPlane(value);
    setIsOutPlane(false);

    let planeType = "";
    if (value === true) {
      planeType = "in-plane";
    }

    onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
  }

  const handleOutPlaneCheckbox = (event, vec) => {
    let value = event.target.checked;
    setIsOutPlane(value);
    setIsInPlane(false);

    let planeType = "";
    if (value === true) {
      planeType = "out-plane";
    }

    onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
  }

  const handlePlaneSelected = (event, vec) => {
    let value = event.target.value;
    console.debug("value", value);
    setPlaneType(value);
    onPlaneVectorRadioSelected(value, vec.initializedIndex);
  }

  return (
    <Paper className="free-vector-resp-answer-container" style={{boxShadow:"none"}} zDepth={1}>

      {/* {clickedBox.length > 0 ?
      <div className="zero-vector-container">
        <h6>Select In and Out of Plane</h6>
        <div >
          <div style={{fontSize:'24px'}}>&#8857;</div>
          <div style={{fontSize:'24px'}}>&#x2297;</div>
        </div>
      </div>
      : null} */}
      <div className="free-vector-resp-answer-canvas">
        <Canvas
          onVectorMoved={onVectorMoved}
          ref={canvasRef}
          ComponentGuid={GetNewComponentGuid()}
          degStepSize={5}
          magStepSize={1}
          stepDeg={false}
          readOnly={showVectorAnswer}
          height={vectorSettings.height}
          width={vectorSettings.width}
          rulerXPoint={vectorSettings.rulerXPoint}
          rulerYPoint={vectorSettings.rulerYPoint}
          stepSize={vectorSettings.stepSize}
          enableGrid={vectorSettings.enableGrid}
          enableBorder={vectorSettings.enableBorder}
          enableRuler={vectorSettings.enableRuler}
          freeBodyDiagram={vectorSettings.image}
          fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
          fbdX={vectorSettings.imageX}
          fbdY={vectorSettings.imageY}
          stepDeg={false}
          gridColor={vectorSettings.gridColor}
          rulerXLabel={vectorSettings.rulerXLabel}
          rulerYLabel={vectorSettings.rulerYLabel}
          commonVectorSettings={vectorSettings}
          vectorAnswerFormulas={vectorAnswerFormulas}
          isAngleOrMagnitudeTextFieldChanged={isAngleOrMagnitudeTextFieldChanged}
          handleAngleMagnitudeTextFieldChange={handleAngleMagnitudeTextFieldChange}
        ></Canvas>
        {/* <div className="arrow-container" style={{margin: 'auto', marginTop: '10px'}}>
          <h6>Draw Vectors</h6>
          {vectorAnswerFormulas.map((_vector, index) => {
            return (
              <div className="arrow-container-child" key={index}>
                <input
                  type="checkbox"
                  onChange={(event) =>
                    onVectorCheckboxClicked(event, _vector, index)
                  }
                  name="add-vector"
                />
                <ReactSVG
                  src={arrowSVG}
                  alt="a"
                  style={{ fill: vectorAnswerFormulas[index].formulaColor }}
                  beforeInjection={(svg) => {
                    console.log("colorcode:", vectorAnswerFormulas[index].formulaColor)
                    svg.classList.add("arrow-svg");
                    svg.setAttribute(
                      "style",
                      `fill: ${vectorAnswerFormulas[index].formulaColor}`
                    );
                  }}
                />
                <MathJax math={_vector && _vector.name?String.raw`$${_vector.name}$`:''} className="options-vector" />
              </div>
            );
          })}
        </div> */}

      <div className="sf-vector-settings h-100" style={{display:"flex",marginLeft:vectors?.length > 0 ? "15%" :"35%",justifyContent:"center",width:vectors?.length > 0? "max-content" :"max-content"}}>
          <div>
             <div className=""  style={{display:"flex",justifyContent:"space-evenly",width:"110%"}}>   

             <div style={{ display: "flex",  fontWeight: "bold" }}>
                            <div style={{ flex: 1, marginLeft: "25px" }}>Vectors</div>
                            {vectors && vectors.filter((vector) => !vector?.isStaticVector)?.length > 0 && (
                                <div style={{ flex: 1, textAlign: "center",marginLeft:"28px",whiteSpace:"nowrap" }}>Vector is zero</div>
                            )}
                        </div>
            </div>
            {vectorAnswerFormulas.map((_vector, index) => {
              return (

                <div style={{display:"flex",justifyContent:"space-between",width:"72%"}}>   
                <div className="vector-checkbox-child" key={index}>
                    <div style={{
                        width: '15px',
                        height: '15px',
                        background: _vector.formulaColor,
                        borderRadius: '10px'
                    }}></div>
                    <div>
                      <input
                        type="checkbox"
                        className="inputCheckboxVector"
                        checked={vectors?.length > 0 ? vectors.some(vector => vector.initializedIndex === index) : false}
                        onChange={(event) =>
                          onVectorCheckboxClicked(event, _vector, index)
                        }
                        color="red"
                        name="add-vector"
                      />
                    </div> 
                  {/* <div className="vector-checkbox-arrow">
                    <ReactSVG
                      src={arrowSVG}
                      alt="a"
                      style={{ fill: _vector?.formulaColor }}
                      beforeInjection={(svg) => {
                        console.log("colorcode:", _vector?.formulaColor)
                        svg.classList.add("arrow-svg");
                        svg.setAttribute(
                          "style",
                          `fill: ${_vector?.formulaColor}`
                        );
                      }}
                    />
                  </div> */}
                  <MathJax math={_vector && _vector.name?String.raw`$${_vector.name}$`:''} />
                </div>
                  <div>
                      {
                        !_vector?.isStaticVector && vectors.some(vector => vector.initializedIndex === index) ?
                        <div className="vector-checkbox-child" key={`vector-checkbox-child${index}`}>
                            <div>
                              <input
                                type="checkbox"
                                 className="inputCheckboxVector"
                                checked={vectors?.length > 0 ? vectors.some(vector => vector.initializedIndex === index && vector.isZeroVector) : false}
                                onChange={(event) =>
                                  onZeroVectorCheckboxClicked(event, index)
                                }
                                name="add-vector"
                              />
                            </div>
                            {/* <div>
                              <ReactSVG
                                src={dotSVG}
                                alt="a"
                                style={{ fill: _vector?.formulaColor }}
                                beforeInjection={(svg) => {
                                  svg.classList.add("dot-svg");
                                  svg.setAttribute(
                                    "style",
                                    `fill: ${_vector?.formulaColor}`
                                  );
                                }}
                              />
                            </div> */}
                        </div>
                        
                        :""
                      }
                  </div>
                </div>
              );
            })}
          </div>

          <div>
          {/* {clickedBox.length > 0 &&
            <div className="">
               <h6>Zero Vector</h6>
              {clickedBox.map((_vector, index) => {
                return (
                  <div className="vector-checkbox-child" key={index}>
                      <div>
                        <input
                          type="checkbox"
                          checked={isZeroVector}
                          onChange={(event) =>
                            onZeroVectorCheckboxClicked(event, _vector.initializedIndex)
                          }
                          name="add-vector"
                        />
                      </div>
                      <div>
                        <ReactSVG
                          src={dotSVG}
                          alt="a"
                          style={{ fill: vectorAnswerFormulas[_vector.initializedIndex]?.formulaColor }}
                          beforeInjection={(svg) => {
                            svg.classList.add("dot-svg");
                            svg.setAttribute(
                              "style",
                              `fill: ${vectorAnswerFormulas[_vector.initializedIndex]?.formulaColor}`
                            );
                          }}
                        />
                      </div>
                  </div>
                );
              })}
            </div>} */}
          </div>
          <div>
          {clickedBox.length > 0 &&
            <div style={{display:'none'}}>
               <h6>In/Out of Plane</h6>
               {clickedBox.map((_vector, index) => {
                return (
                  <div className="vector-checkbox-child" key={"index"} style={{ gap: '1rem' }}>
                    <div className="vector-checkbox-child">
                        <input
                          type="checkbox"
                          checked={isInPlane}
                          onChange={(event) => handleInPlaneCheckbox(event, _vector)}
                          name="add-vector"
                        />
                      <div style={{ fontSize: '20px' }}>{"\u2297"}</div>
                    </div>
                    <div className="vector-checkbox-child">
                        <input
                          type="checkbox"
                          checked={isOutPlane}
                          onChange={(event) => handleOutPlaneCheckbox(event, _vector)}
                          name="add-vector"
                        />
                      <div style={{ fontSize: '20px' }}>{"\u2299"}</div>
                    </div>
                  </div>
                )
               })}
            </div>}
          </div>
        </div>
              <div className="arrow-options-container">
        <div className="arrow-options-inputs">
          {/* <h4>Select the vector to display, then click and drag the tip of the vector{showComponents || showMagnitudeAngle ? " or enter values below to change vector" : null}. If you need more space, click and drag the stem of the vector to move it.</h4> */}
          {/* <FreeFormInputs
            vectorAnswerFormulas={vectorAnswerFormulas}
            vectors={vectors}
            onChange={onChange}
            showComponents = {showComponents}
            showMagnitudeAngle = {showMagnitudeAngle}
          /> */}
         <div className="mt-3">
                <div className="font-weight-bold fontClass-14" style={{fontWeight:"bold"}}>How to enter the answer:</div>
                <ol className="fontClass-14 mt-1">
                    <li>Select the vector to display</li>
                    <li>Click and drag the tip of the vector / enter values below to change vector. </li>
                    <li>If you require more space, click and drag the stem of the vector to move it.</li>
                </ol>
            </div>
        </div>
      </div> 

      </div>
    </Paper>
  );
};

const FreeFormInputs = ({ vectorAnswerFormulas, vectors, onChange,showComponents, showMagnitudeAngle }) => {
  let Indexes = [];
  if(vectors.length > 0){
    Indexes = vectors.map((_v)=> _v.initializedIndex)
  }

  //FreeFormInput
  return vectorAnswerFormulas.map((_vector, index) => {
    if (_vector?.isStaticVector) {
      return "" // Static vector
    }
    return (
      <FreeFormInput
        _vector={_vector}
        index={index}
        key={index}
        vector={Indexes.includes(index) ? vectors.find((_v) => _v.initializedIndex === index) || { x: 0, y: 0 } : { x: 0, y: 0 }}
        onChange={onChange}
        showComponents={showComponents}
        showMagnitudeAngle={showMagnitudeAngle}
      />
    );
  });
};

const calcAngleDegrees = (x, y) => {
  return (Math.atan2(y, x) * 180) / Math.PI;
};

const calculateMagnitude = (x, y) => {
  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
};

const generateVectorComponents = (angle, mag) => {
  console.log('angle, mag',angle, mag);
  return {
    x: Math.cos(angle * (Math.PI / 180)) * parseFloat(mag),
    y: Math.sin(angle * (Math.PI / 180)) * parseFloat(mag),
  };
};

/* const onAngleMagChanged = (angle,magnitude,onVectorValueChange) => {
  const {x,y} = generateVectorComponents(angle,magnitude);
  onVectorValueChange('x',x);
  onVectorValueChange('y',y);
} */
const onAngleMagChanged = (angle,magnitude,vector,index,onChange) => {
  const {x,y} = generateVectorComponents(angle,magnitude);
  const _vector = { ...vector };
  _vector["x"] = parseFloat(x);
  _vector["y"] = parseFloat(y);
  _vector['index'] = index;
  console.debug("_vector=========", _vector)
  onChange(_vector, "angleMag");
}


const FreeFormInput = ({ _vector, index, vector, onChange, showComponents, showMagnitudeAngle  }) => {
  const { name } = _vector;
  const { x = 0, y = 0, z = 0 } = vector;
  const [angle,setAngle] = useState(0);
  const [magnitude,setMagnitude] = useState(0);

  console.debug("vectorvector", vector)

  const onVectorValueChange = (key, value) => {
    const _vector = { ...vector };
    _vector[key] = parseFloat(value);
    _vector['index'] = index;
    console.debug("_vector=========", _vector)
    onChange(_vector, key);
  };

  useEffect(()=>{
    setAngle(calcAngleDegrees(x,y));
    setMagnitude(calculateMagnitude(x,y));
  },[x,y]);

  return (
    <div className="arrow-options-input-container">
     {(showComponents || showMagnitudeAngle) && <h4>
        <MathJax math={name?String.raw`$${name}$`:''} />
      </h4>} 
     {showComponents && <TextField
        id="x-center-title"
        label="x"
        lineDirection="center"
        placeholder="x"
        value={x | ""}
        onChange={(value) => onVectorValueChange("x", value)}
        type="number"
        className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
        style={{fontFamily: "MathJax_Main !important", minWidth:'90px', display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block' }}
        size={10}
        fullWidth={false}
        autoComplete="off"
      />}
      {showComponents && <TextField
        id="y-center-title"
        label="y"
        lineDirection="center"
        placeholder="y"
        value={y | ""}
        onChange={(value) => onVectorValueChange("y", value)}
        type="number"
        className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
        style={{fontFamily: "MathJax_Main !important", minWidth:'90px', display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block'}}
        size={10}
        fullWidth={false}
        autoComplete="off"
      />}

      {(vector.plane === "out-plane" || vector.plane === "in-plane") && <TextField
        id="z-center-title"
        label="z"
        lineDirection="center"
        placeholder="z"
        value={z | ""}
        onChange={(value) => onVectorValueChange("z", value)}
        type="number"
        className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
        style={{fontFamily: "MathJax_Main !important", minWidth:'90px'}}
        size={10}
        fullWidth={false}
        autoComplete="off"
      />}
      
      {showMagnitudeAngle && <TextField
        className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
        style={{fontFamily: "MathJax_Main !important", minWidth:'90px'}}
        size={10}
        fullWidth={false}
        autoComplete="off"
        id="magnitude-center-title"
        label="Magnitude"
        lineDirection="center"
        placeholder="magnitude"
        value={magnitude ? magnitude.toFixed(1) : ""}
        type="number"
        step={0.1}
        onChange={(_magnitude) => {
          console.debug("_magnitude", _magnitude, magnitude)
          onAngleMagChanged(angle,_magnitude,vector, index, onChange)
        }}
      />}
      {showMagnitudeAngle && <TextField
        id="angle-center-title"
        label="Angle"
        lineDirection="center"
        placeholder="angle"
        value={angle ? angle.toFixed(1) : ""}
        type="number"
        onChange={(_angle) => onAngleMagChanged(_angle,magnitude,vector, index, onChange)}
        className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
        style={{fontFamily: "MathJax_Main !important", minWidth:'90px', display: vector.plane === "out-plane" || vector.plane === "in-plane" ? 'none' :'block'}}
        size={10}
        fullWidth={false}
        autoComplete="off"
      /> }
      {/* <div>
          <label htmlFor="angle">Angle</label>
          <input 
            id="angle"
            name="angle"
            type="number" 
            className="text-fields__application__price md-cell md-cell--3 md-cell--1-phone"
            style={{fontFamily: "MathJax_Main !important", minWidth:'90px'}}
            placeholder="angle"
            // value={angle | ""}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                let val = event.target.value;
                let _angle = parseInt(val);
                if (!isNaN(_angle)) {
                  console.debug("_angle", _angle)
                  onAngleMagChanged(_angle,magnitude,vector, index, onChange)
                }
              }
              
            }}
            />
      </div> */}
    </div>
  );
};


export default VectorFreeFormAnswerLivePreview;
